import { createFileRoute, Link } from "@tanstack/react-router";
import { ConnectAiDocs } from "@/components/setup/connect-ai-docs";
import { SetupCopyBlock } from "@/components/setup/SetupCopyBlock";

export const Route = createFileRoute("/docs/connecting-accounts")({
	component: ConnectingAccounts,
});

function ConnectingAccounts() {
	return (
		<article className="space-y-10">
			<div className="space-y-2">
				<h1 className="text-2xl font-medium tracking-tight">
					Connecting accounts
				</h1>
				<p className="text-sm text-muted-foreground">
					Link your social platforms to AgentReacher.
				</p>
			</div>
			<div className="space-y-4 text-sm leading-relaxed text-muted-foreground">
				<p>
					AgentReacher supports publishing to Instagram, Facebook, X, YouTube,
					TikTok, Pinterest, LinkedIn, Threads, and Bluesky.
				</p>
				<ConnectAiDocs />
				<p>Tell your assistant things like:</p>
				<div className="grid gap-2">
					<SetupCopyBlock
						text="What social accounts do I have connected?"
						multiline
					/>
					<SetupCopyBlock text="Connect my Bluesky account." multiline />
					<SetupCopyBlock
						text="Show me my Instagram connection status."
						multiline
					/>
				</div>
				<p>
					The assistant uses{" "}
					<code className="rounded bg-muted px-1.5 py-0.5 text-xs font-mono text-foreground">
						integrationList
					</code>{" "}
					to check your connections and{" "}
					<code className="rounded bg-muted px-1.5 py-0.5 text-xs font-mono text-foreground">
						integrationConnect
					</code>{" "}
					to initiate new ones. For OAuth-based platforms, the assistant will
					provide an authorization URL for you to complete in your browser.
				</p>

				<h2 className="text-base font-medium text-foreground pt-2">
					Or use the dashboard
				</h2>
				<ol className="list-decimal pl-5 space-y-2">
					<li>
						Go to the <strong className="text-foreground">Connections</strong>{" "}
						tab.
					</li>
					<li>
						Click the platform you want to connect and follow the OAuth flow to
						authorize AgentReacher.
					</li>
					<li>
						Once connected, the account appears in your connections list and
						becomes available as a target when creating posts.
					</li>
				</ol>
				<p>
					You can disconnect an account at any time. Disconnecting does not
					delete posts already published to that platform.
				</p>
			</div>

			<div className="flex items-center gap-4 text-sm">
				<Link
					to="/docs/roles"
					className="text-muted-foreground hover:text-foreground transition-colors"
				>
					&larr; Roles and permissions
				</Link>
				<Link
					to="/docs/mcp"
					className="text-primary hover:text-primary/80 transition-colors ml-auto"
				>
					MCP overview &rarr;
				</Link>
			</div>
		</article>
	);
}
